export const NO_SPACES_REGEX = /^[\S]+$/g;
export const TWO_DECIMAL_PLACES_REGEX = /^(\d+)(\.\d{1,2})?$/;
export const THREE_DECIMAL_PLACES_REGEX = /^(\d+)(\.\d{1,3})?$/;
export const VALID_CHARACTER_REGEX = /^[\p{L}\p{N}\-_.!*'()]+$/u;
export const ONLY_DIGITS_REGEX = /^\d+$/;
